import { useCallback } from "react";
import { v4 } from "uuid";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { trackEvent } from "../../../../utils/analytics";
import type { Nurse } from "../../../../utils/models";
import { usePostStaffMessage } from "../hooks";

type useDirectMessagesProps = {
	onClose: () => void;
};

export const useDirectMessages = ({ onClose }: useDirectMessagesProps) => {
	const { getNurseById } = useHospitalData();
	const { mutateAsync: postBroadcastMessage, isPending: isLoading, isSuccess } = usePostStaffMessage();

	const handleSendMessage = useCallback(
		async (message: string, nurseId: number): Promise<void> => {
			const nurse: Nurse | undefined = getNurseById(nurseId);

			if (!nurse || !nurse.userId) return;

			await postBroadcastMessage({
				message: message.trim(),
				userIds: [nurse.userId],
				tempId: v4(),
			});
			trackEvent("send_direct_message", { message, nurseId });
			onClose();
		},
		[getNurseById, onClose, postBroadcastMessage],
	);

	return { handleSendMessage, isLoading, isSuccess };
};
